import React, { useState } from 'react';
import { Container, TextInput, Slider, NumberInput, Table, Text, Card, Grid } from '@mantine/core';
import { IconCurrencyDollar } from '@tabler/icons-react';

const LinokCalculator = () => {
    const [herdSize, setHerdSize] = useState(0);
    const [damagePerCow, setDamagePerCow] = useState(150);
    const [lossIncome, setLossIncome] = useState(0);
    const [fatDetectionLoss, setFatDetectionLoss] = useState(0);
    const [improvmentPrecentage, setImprovmentPrecentage] = useState(50);
    const [milkingStations, setMilkingStations] = useState(0);

    const linokFeePerStation = 900;
    const linokSoftwareFee = 18;

    const totalDamage = (herdSize * damagePerCow) + lossIncome;
    const reducedDamage = totalDamage * (improvmentPrecentage / 100);
    const totalLinokFee = milkingStations * linokFeePerStation + herdSize * linokSoftwareFee;
    const roiReturn = reducedDamage - totalLinokFee;

    const numberInputHandler =
        (setter: React.Dispatch<React.SetStateAction<number>>) =>
        (value: number | '') => setter(typeof value === 'number' ? value : 0);

    const formatNumber = (num: number) =>
        new Intl.NumberFormat('en-US').format(Math.round(num));

    return (
        <Container size="md" style={{ padding: '30px' }}>
            <Card shadow='lg' padding="lg" radius='lg' withBorder style={{ borderColor: '#f3f3f3' }}>
                <Text size="xl" weight={700} align="center" mb="lg">
                    Linok Calculator
                </Text>

                <Grid gutter={'lg'}>
                    <Grid.Col sm={6} xs={12}>

                        <Grid gutter={'lg'}>
                            <Grid.Col xs={12}>
                                {/* <TextInput
                                    variant='filled'
                                    size='md'

                                    label="Herd Size"
                                    placeholder="Enter the number of cows"
                                    type="number"
                                    value={herdSize}
                                    onChange={(e) => setHerdSize(Number(e.target.value))}
                                    required
                                /> */}
                                                               <NumberInput
                                    // icon={<IconCurrencyDollar size={16} />}
                                    labelProps={{ size: 15 }}
                                    variant='filled'
                                    size='md'
                                    min={0}
                                    label="Herd Size"
                                    placeholder="Enter the number of cows"
                                    value={herdSize}
                                    onChange={numberInputHandler(setHerdSize)}
                                    required
                                />
                            </Grid.Col>
                            <Grid.Col xs={12}>
                                <NumberInput
                                    variant='filled'
                                    size='md'
                                    labelProps={{ size: 15 }}
min={0}
                                    label="Number of Milking Stations"
                                    placeholder="Enter the number of stations"
                                    value={milkingStations}
                                    onChange={numberInputHandler(setMilkingStations)}
                                    required
                                />
                            </Grid.Col>

                        </Grid>
                    </Grid.Col>
                    <Grid.Col sm={6} xs={12}>

                        <Grid gutter={'lg'}>
                            <Grid.Col xs={12}>
                                <NumberInput
                                    icon={<IconCurrencyDollar size={16} />}
                                    labelProps={{ size: 15 }}
                                    variant='filled'
                                    size='md'
                                    min={0}
                                    label="Lost Income Due to High SCC"
                                    placeholder="Enter estimated loss"
                                    value={lossIncome}
                                    onChange={numberInputHandler(setLossIncome)}
                                    required
                                />
                            </Grid.Col>

                            <Grid.Col xs={12}>
                                <Text size={16} weight={400} mt={0}>Annual Loss Due to Mastitis</Text>
                                <Slider
                                    size={'xl'}
                                    color='cyan'
                                    //   labelAlwaysOn
                                    marks={Array.from({ length: 3 }, (_, i) => ({ value: 100 + i * 50, label: `$${100 + i * 50}` }))}
                                    min={100}
                                    max={200}
                                    // step={10}
                                    value={damagePerCow}
                                    onChange={setDamagePerCow}
                                    //   label={`$${damagePerCow}`}
                                    mt={3}
                                />
                            </Grid.Col>

                            <Grid.Col xs={12}>
                                <Text size={16} weight={400} mt={10}>Improvement</Text>
                                <Slider
                                    size={'xl'}
                                    color='cyan'
                                    //   labelAlwaysOn
                                    marks={[{ value: 0, label: "0%" }, { value: 50, label: "50%" }, { value: 100, label: "100%" }]}
                                    min={0}
                                    max={100}
                                    // step={10}
                                    value={improvmentPrecentage}
                                    onChange={setImprovmentPrecentage}
                                    //   label={`$${damagePerCow}`}
                                    mt={3}
                                />
                            </Grid.Col>

                        </Grid>

                    </Grid.Col>

                </Grid>

                <Table highlightOnHover mt="xl" style={{marginTop:50}}>
                    <tbody>
                        <tr>
                            <td>Annual Loss</td>
                            <td>${formatNumber(totalDamage)}</td>
                        </tr>
                        <tr>
                            <td style={{fontWeight: 700}}>Cost Savings ({improvmentPrecentage}%)</td>
                            <td style={{fontWeight: 700}}>${formatNumber(reducedDamage)}</td>
                        </tr>
                        {/* <tr>
                            <td>Linok ROI</td>
                            <td>${formatNumber(roiReturn)}</td>
                        </tr> */}
                    </tbody>
                </Table>
            </Card>
        </Container>
    );
};

export default LinokCalculator;
